import React, { useEffect } from "react";
import { useLazyGetTransactionsFilteredQuery } from "../../../features/transactions/transactionsApiSlice";

const FilteredTransactionsFetcher = ({ filters, onDataFetched }) => {
  const [fetchTransactions, { data, isLoading }] = useLazyGetTransactionsFilteredQuery();

  useEffect(() => {
    // Always fetch data - backend handles permission filtering
    fetchTransactions({ page: 1, limit: 99999, filters });
  }, [filters, fetchTransactions]);

  useEffect(() => {
    if (data && onDataFetched) {
      onDataFetched(data);
    }
  }, [data, onDataFetched]);

  return null; // no UI rendered
};

export default FilteredTransactionsFetcher;

